//網紅客戶轉去專頁
//获取 cookie 值的函数
function getCookie(cname)
{
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++) 
  {
    var c = ca[i].trim();
    if (c.indexOf(name)==0) return c.substring(name.length,c.length);
  }
  return "";
}

var x = getCookie("distributor");


if (x == "Laura"){
location.href = "/pages/laura";
document.write('<meta http-equiv="refresh" content="0;url=https://www.sealvax.com/pages/laura">');
}

if (x == "yurakumama"){
location.href = "/pages/yurakumama";
document.write('<meta http-equiv="refresh" content="0;url=https://www.sealvax.com/pages/yurakumama">');
}

if (x == "kellysdiary88"){
location.href = "/pages/kellysdiary88";
document.write('<meta http-equiv="refresh" content="0;url=https://www.sealvax.com/pages/kellysdiary88">');
}

if (x == "AD"){
location.href = "/pages/ad";
document.write('<meta http-equiv="refresh" content="0;url=https://www.sealvax.com/pages/ad">');
}


if (x == "xinxincuisine"){
location.href = "/pages/xinxincuisine";
document.write('<meta http-equiv="refresh" content="0;url=https://www.sealvax.com/pages/xinxincuisine">');
}


if (x == "kol"){
location.href = "/pages/kol";
document.write('<meta http-equiv="refresh" content="0;url=https://www.sealvax.com/pages/kol">');
}


if (x == "millie"){
location.href = "/pages/m";
document.write('<meta http-equiv="refresh" content="0;url=https://www.sealvax.com/pages/m">');
}



